var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagCzechiaRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5719 0H0V12H20.5719V0Z",
    fill: "#C40028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5719 0H0V5.99877H20.5719V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V12L9.00028 5.99878L0 0Z",
    fill: "#29457C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCzechiaRectangle);
export default __webpack_public_path__ + "static/media/flag-czechia-rectangle.8476a050e71c2974ce0ccc7c036e28ad.svg";
export { ForwardRef as ReactComponent };